import { RootState } from "./store";

export const selectGeneratePinProps = (state: RootState) => {
  return state.modal.generatePin;
};

export const selectCompleteServiceRecordProps = (state: RootState) => {
  return state.modal.completeServiceRecord;
};

export const selectMachineSearchServiceProps = (state: RootState) => {
  return state.modal.machineSearchService;
};

export const selectRequestSoftwareProps = (state: RootState) => {
  return state.modal.requestSoftware;
};

export const selectDiffViewer = (state: RootState) => {
  return state.modal.diffViewer;
};

export const selectUploadSoftwareProps = (state: RootState) => {
  return state.modal.uploadSoftware;
};

export const selectAddMachine = (state: RootState) => {
  return state.modal.addMachine;
};

export const selectAddComment = (state: RootState) => {
  return state.modal.addComment;
};

export const selectEditMachine = (state: RootState) => {
  return state.modal.editMachine;
};

export const selectEditComment = (state: RootState) => {
  return state.modal.editComment;
};

export const selectAddUser = (state: RootState) => {
  return state.modal.addUser;
};

export const selectEditUser = (state: RootState) => {
  return state.modal.editUser;
};

export const selectUploadLog = (state: RootState) => {
  return state.modal.uploadLog;
};

export const selectDeleteSoftware = (state: RootState) => {
  return state.modal.deleteSoftware;
};

export const selectSoftwareInfo = (state: RootState) => {
  return state.modal.softwareInfo;
};

export const selectEditSoftware = (state: RootState) => {
  return state.modal.editSoftware;
};
